export var RIPPLE_COLOR = '#999';
export var RIPPLE_CONFIG = { stiffness: 36, damping: 18 };
export var RIPPLE_OPACITY = 0.3;
export var ABBREV_DECIMALS = 2;
export var NO_DURATION = '--:--:--';
export var NOT_AVAILABLE_LABEL = 'N/A';
export var UNITS_RECORDS = 'RECORDS';
export var UNITS_PERCENTAGE = 'PERCENTAGE';
export var UNITS_AMOUNT = 'AMOUNT';
export var DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
export var DEFAULT_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';
//# sourceMappingURL=constants.js.map